import {
  AppointmentAction,
  ServiceCodeType,
} from '@principle-theorem/principle-core/interfaces';
import {
  IAppointmentScopedFact,
  IBigQueryChartedTreatment,
  ITimestampedFact,
} from './common';

export interface IAppointmentEventFact
  extends IAppointmentScopedFact,
    ITimestampedFact {
  action: AppointmentAction;
  timeUntilAppointment?: number;
  treatments: IBigQueryChartedTreatment[];
  serviceCodes: ISerialisedScopedServiceCode[];
  duration: number;
  nextAppointmentBooked: boolean;
  isFirstAppointment: boolean;
  waitTime: number;
  // TODO: Requires tracking on the treatments how much has been charged on an invoice and how much remaining
  treatmentCost: number;
}

export interface ISerialisedScopedServiceCode {
  code: string;
  type: ServiceCodeType;
}
